<template>
  <nav class="block md:hidden !bg-white !bg-opacity-90 !backdrop-blur-lg fixed w-full z-50 top-0">
    <Container full-width-on-mobile>
      <div class="flex justify-between items-center">
        <!-- Start Left -->

        <IconButton as="link" :href="Routes.get('root_url')" variant="secondary" target-size="lg"><ChevronLeftLargeIcon class="-translate-x-3 !text-brand-typo" /></IconButton>

        <div v-if="store.selectedImage !== null" class="flex">
          <IconButton @mousedown="toggleCompareBefore" @mouseup="toggleCompareAfter" @touchstart="toggleCompareBefore" @touchend="toggleCompareAfter" variant="secondary"><CompareIcon :class="{ 'text-brand-typo': store.viewMode == ViewMode.Before, 'text-typo': store.viewMode == ViewMode.After }" /></IconButton>
          <IconButton variant="secondary" :disabled="!currentPersistentStore?.canUndo" @click="currentPersistentStore?.undo"><UndoIcon /></IconButton>
          <IconButton variant="secondary" :disabled="!currentPersistentStore?.canRedo" @click="currentPersistentStore?.redo"><RedoIcon /></IconButton>
        </div>
        <!-- End Left -->

        <!-- Start Right -->
        <div class="flex items-center gap-2 !pr-2">
          <SelectImageDialog />
          <ImageButton @click="uploadFile" class="!border-secondary-hover !shadow-sm sm:!m-2 sm:!mb-0">
            <div class="bg-secondary-hover h-full flex justify-center items-center">
              <AddIcon />
            </div>
          </ImageButton>
        </div>
        <!-- End Right -->
      </div>
    </Container>
  </nav>
</template>

<script setup lang="ts">
import { ImageButton, AddIcon, ChevronLeftLargeIcon, IconButton, CompareIcon, Container, RedoIcon, UndoIcon } from "prism";
import SelectImageDialog from "@/components/upload/select_image_dialog.vue";
import Routes from "@/modules/routes";
import { useEditorStore, ViewMode } from "@/stores/editor_store";

interface HeaderProps {
  currentPersistentStore?: any;
}

const props = defineProps<HeaderProps>();
const store = useEditorStore();

const emit = defineEmits<{
  (e: "toggleCompareBefore"): void;
  (e: "toggleCompareAfter"): void;
}>();

const toggleCompareBefore = () => {
  emit("toggleCompareBefore");
};

const toggleCompareAfter = () => {
  emit("toggleCompareAfter");
};

const uploadFile = () => {
  window.onUploadFile();
};
</script>
